var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav-bar'),(_vm.isAdmin)?_c('AdminSideBar'):_vm._e(),_c('div',{staticClass:"container content"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }